module.exports = __webpack_public_path__ + "img/nicetohave-product-design-03.4a76b741.jpg";